import { Injectable, signal } from '@angular/core';

/** Immersive mode for service pages: the app shell hides the sidebar and drops
 *  its content padding so the page owns the whole viewport. Held in a root
 *  service because the toggle lives inside a page while the shell (AppComponent)
 *  is the one that has to react. */
@Injectable({ providedIn: 'root' })
export class FullscreenService {
  readonly active = signal(false);

  toggle(): void {
    this.active.update((v) => !v);
  }

  exit(): void {
    this.active.set(false);
  }
}
